export const ELEVATE_HISPANO_SLUG = 'elevate-hispano';
export const ELEVATE_EVENT_URL = 'https://elevate.erpelantar.com';
export const ELEVATE_HISPANO_LOGO_SRC = '/elevate/elevate-hispano-logo.png';
export const ELEVATE_HISPANO_STAGE_SRC = '/elevate/elevate-hispano-stage.jpg';
export const ELEVATE_HISPANO_EVENT_SRC = '/elevate/elevate-hispano-event.jpg';
export const ELEVATE_HISPANO_TICKET_VIDEO_SRC = '/elevate/elevate-hispano-ticket.mp4';
export const ELEVATE_GIFT_REQUIRED_PURCHASES = 5;
export const ELEVATE_WELCOME_DISCOUNT_PERCENT = 10;
export const EVOLUCION_90_REGISTER_URL =
  'https://academy.elantartech.com/es_419/event';
export const BANNERS_NEW_HOME_SRC = '/elevate/banners-web-new-home-3-sep.png';

/**
 * Query order is always: ref → username → email.
 * For buy links these belong to the person who referred the opener (not the opener).
 * Empty values stay present as empty strings.
 */
export function buildElevateEventUrl({
  refCode = '',
  username = '',
  email = '',
  discountPercent = null,
  platformCode = null,
  points = null,
} = {}) {
  const params = new URLSearchParams();
  params.set('ref', typeof refCode === 'string' ? refCode.trim() : '');
  params.set('username', typeof username === 'string' ? username.trim() : '');
  params.set('email', typeof email === 'string' ? email.trim() : '');
  if (discountPercent) {
    params.set('discount', String(discountPercent));
  }
  if (platformCode) {
    params.set('platform', String(platformCode));
  }
  if (points) {
    params.set('points', String(points));
  }
  return `${ELEVATE_EVENT_URL}?${params.toString()}`;
}

export function buildElevateBuyUrl(user, { discountPercent = null, platformCode = null, points = null } = {}) {
  return buildElevateEventUrl({
    refCode: user?.referred_by_referral_code || '',
    username: user?.referred_by_username || '',
    email: user?.referred_by_email || '',
    discountPercent,
    platformCode,
    points,
  });
}
